import React from 'react'

export default function Invoices(props) {
    // props
    const { orderDetails } = props

    return (
        <div className="invoices-view">
            <h1>Invoices</h1>
        </div>
    )
}
